import { render, staticRenderFns } from "./pharmacist-course.vue?vue&type=template&id=15457f3b&scoped=true&"
import script from "./pharmacist-course.vue?vue&type=script&lang=js&"
export * from "./pharmacist-course.vue?vue&type=script&lang=js&"
import style0 from "./pharmacist-course.vue?vue&type=style&index=0&id=15457f3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15457f3b",
  null
  
)

export default component.exports